export function resolveApiBaseUrl(configuredUrl: string | undefined, developmentFallback?: string): string {
  const apiUrl = configuredUrl?.trim()
  if (apiUrl) return apiUrl
  if (developmentFallback) return developmentFallback

  throw new Error('VITE_API_URL is required outside development')
}

export const API_BASE_URL = resolveApiBaseUrl(
  import.meta.env.VITE_API_URL,
  import.meta.env.DEV ? 'http://localhost:3000' : undefined
)
